const steps = [
  { num: '①', text: '傾聽與需求分析' },
  { num: '②', text: '既有保單健檢與缺口診斷' },
  { num: '③', text: '結構化設計：保障層 × 現金流 × 預算' },
  { num: '④', text: '長期追蹤：年度檢視與調整' },
];

export default function AboutMethod() {
  return (
    <section id="method-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            MY APPROACH
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            我的方法與信念
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Two Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
          {/* Left: Steps */}
          <div className="bg-[#F8F5F0] rounded-3xl p-10">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#5C5470]/10">
                <i className="ri-list-check-2 text-[#5C5470] text-xl"></i>
              </div>
              <h3
                className="font-serif font-bold text-[#5C5470]"
                style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
              >
                貼心四步驟
              </h3>
            </div>
            <div className="space-y-5">
              {steps.map((s, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-[#D4A373] text-white font-bold flex-shrink-0"
                    style={{ fontSize: '1rem' }}
                  >
                    {i + 1}
                  </div>
                  <div className="flex-1 pt-1.5">
                    <p className="text-[#5C5470] font-medium" style={{ fontSize: '1.1875rem', lineHeight: '1.6' }}>
                      {s.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Philosophy */}
          <div className="bg-[#5C5470] rounded-3xl p-10 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/15">
                  <i className="ri-lightbulb-line text-[#D4A373] text-xl"></i>
                </div>
                <h3
                  className="font-serif font-bold text-white"
                  style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
                >
                  專業理念
                </h3>
              </div>
              <i className="ri-double-quotes-l text-[#D4A373]/40 text-6xl block mb-4"></i>
              <p
                className="text-white/85 italic"
                style={{ fontSize: '1.1875rem', lineHeight: '1.85' }}
              >
                好的保險不是商品堆疊，而是結構設計。我的角色是把您想守護的人與事，化成能承受意外與疾病的系統，讓您面對風雨依然能安住其間。
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-white/15">
              <p className="text-[#D4A373] font-semibold" style={{ fontSize: '1.0625rem' }}>— 陳琮恩</p>
              <p className="text-white/50 mt-1" style={{ fontSize: '1rem' }}>保險建築師</p>
            </div>
          </div>
        </div>

        {/* CTA Block */}
        <div className="bg-[#F8F5F0] rounded-3xl p-10 lg:p-14 text-center">
          <h2
            className="font-serif font-bold text-[#5C5470] mb-4"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            想把在乎的人，做好長久的守護嗎？
          </h2>
          <p
            className="text-gray-600 max-w-xl mx-auto mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            把您的擔心跟我說，我會先理解，再為您設計適合的保障結構。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </a>
            <a
              href="#download-form"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('health-check-form')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-download-line"></i>
              下載保單健檢表
            </a>
          </div>
        </div>

        {/* Health Check Form */}
        <div id="health-check-form" className="mt-16 bg-white border border-[#D4A373]/30 rounded-3xl p-10 lg:p-14">
          <div className="max-w-2xl mx-auto">
            <h3
              className="font-serif font-bold text-[#5C5470] mb-2 text-center"
              style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
            >
              免費保單健檢申請
            </h3>
            <p className="text-gray-500 text-center mb-8" style={{ fontSize: '1.0625rem' }}>
              填寫以下資料，琮恩將在 1–2 個工作天內與您聯繫
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d7oe6t0ltb4nd0kphc50"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
                try {
                  const res = await fetch('https://readdy.ai/api/form/d7oe6t0ltb4nd0kphc50', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: data.toString(),
                  });
                  if (res.ok) {
                    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                    if (btn) { btn.textContent = '✓ 已送出，我們將盡快聯繫您！'; btn.disabled = true; btn.className = btn.className + ' opacity-70'; }
                    form.reset();
                  }
                } catch {
                  alert('送出失敗，請稍後再試');
                }
              }}
              className="space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>姓名 *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="您的姓名"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                    style={{ fontSize: '1.0625rem' }}
                  />
                </div>
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>電話 *</label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    placeholder="09XX-XXX-XXX"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                    style={{ fontSize: '1.0625rem' }}
                  />
                </div>
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>電子郵件</label>
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                  style={{ fontSize: '1.0625rem' }}
                />
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>目前保障狀況</label>
                <select
                  name="insurance_status"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors bg-white cursor-pointer"
                  style={{ fontSize: '1.0625rem' }}
                >
                  <option value="">請選擇</option>
                  <option value="no_insurance">目前沒有任何保險</option>
                  <option value="basic_only">只有基本壽險或意外險</option>
                  <option value="some_policies">有幾張保單但不確定夠不夠</option>
                  <option value="want_review">想全面健檢現有保單</option>
                </select>
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>想了解的方向（可複選）</label>
                <div className="grid grid-cols-2 gap-3">
                  {['醫療保障', '家庭保障', '退休規劃', '資產防護'].map((opt) => (
                    <label key={opt} className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" name="interest" value={opt} className="w-4 h-4 accent-[#D4A373]" />
                      <span className="text-gray-600" style={{ fontSize: '1.0625rem' }}>{opt}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>其他想說的話</label>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  placeholder="例如：最近剛生小孩，想了解家庭保障怎麼規劃…"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors resize-none"
                  style={{ fontSize: '1.0625rem' }}
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-[#D4A373] text-white py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-[1.02]"
                style={{ fontSize: '1.1875rem' }}
              >
                送出申請
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
